import React from 'react';
import PropTypes from 'prop-types';

const ContasRow = (props) => {
    return (
        <tr>
            <td>{props.conta.nome}{props.conta.visivel ? "" : " (Não listada)"}</td>
            <td>
                <i className="far fa-edit" style={{ cursor: "pointer" }}
                    onClick={() => props.handleUpdate(props.conta)} />
                {" | "}
                <i className="far fa-trash-alt" style={{ cursor: "pointer" }}
                    onClick={() => props.handleDelete(props.conta.id)} />
            </td>
        </tr>
    );
};

ContasRow.propTypes = {
    conta: PropTypes.object.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func.isRequired,
};

export default ContasRow;


// WEBPACK FOOTER //
// ./src/components/contas/ContasRow.js